/* eslint-disable no-undef */
import { ERR_PUBLISH_FAILED } from '@/js/utils';
import awsIot from 'aws-iot-device-sdk';

// const KEEP_ALIVE = 30; // Keep-alive timeout set to 30 seconds
let instance;
class Mqtt {
  static getInstance(params) {
    if (!instance) {
      instance = new Mqtt(params);
    }
    return instance;
  }

  constructor({
    onConnectCallback,
    onFailureCallback,
    onConnectionLostCallback,
    onMessageArrivedCallback,
    webClientID,
    hostName,
    protocol,
  }) {
    this.mqtt = awsIot.device({
      clientId: webClientID,
      host: hostName,
      protocol,
      accessKeyId: AWS.config.credentials.accessKeyId,
      secretKey: AWS.config.credentials.secretAccessKey,
      sessionToken: AWS.config.credentials.sessionToken,
      properties: {
        payloadFormatIndicator: false,
      },
      // autoReconnect: false,
    });

    this.mqtt.on('connect', onConnectCallback);
    this.mqtt.on('error', onFailureCallback);
    this.mqtt.on('offline', onConnectionLostCallback);
    this.mqtt.on('message', onMessageArrivedCallback);

    /*
      device.on('connect', function (res) {
        console.log('connected', res);
        // publishMessage(device, 'demoTopic', 'demo success!');
      });
      device.on('message', function (topic, payload) {
        console.log('message', topic, payload.toString());
      });
      device.on('error', function (err) {
        console.log('mqtt error', err);
      });
      function publishMessage(device, topic, msg) {
        device.publish(topic, msg, { qos: 0 }, function (err) {
          if (err) {
            console.log('failed to publish iot message!');
            console.error(err);
          } else {
            console.log('published to demoTopic');
            console.log(
              'Message Published',
              'Topic: ' + topic,
              'Message: ' + msg
            );
          }
        });
      } */

    // this.mqtt.onMessageArrived = onMessageArrivedCallback;
  }

  publishTopic(topic, data) {
    if (!topic) return;
    try {
      this.mqtt.publish(
        topic,
        typeof data === 'string' ? data : JSON.stringify(data || ''),
        { qos: 0 }
      );
      return Promise.resolve();
    } catch (err) {
      console.log(err);
      return Promise.reject(new Error(ERR_PUBLISH_FAILED));
    }
  }

  subscribeTopic(topic) {
    if (topic) this.mqtt.subscribe(topic);
  }

  unsubscribeTopic(topic) {
    if (topic) this.mqtt.unsubscribe(topic);
  }

  disconnect() {
    this.mqtt.disconnect();
  }
}

export default Mqtt.getInstance;
